import {
  getAuth,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "../../components/Button/Button";
import Layout from "../../components/Layout/Layout";
import Logo from "../../components/Logo/Logo";
import TextInput from "../../components/TextInput/TextInput";
import { auth } from "../../firebase";
import UserContext from "../../context/UserContext";
import "./Login.scss";

const LoginPage = () => {
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [userMessage, setUserMessage] = useState("");

  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const login = async (event) => {
    event.preventDefault();

    try {
      // sign in with firebase
      await signInWithEmailAndPassword(auth, loginEmail, loginPassword);
      // navigate to the dashboard
      navigate("/dashboard");
    } catch (error) {
      if (error.code === "auth/user-not-found") {
        setUserMessage("Your Email has not been recognized.");
      }
      if (error.code === "auth/wrong-password") {
        setUserMessage("Your Password has not been recognized.");
      }
    }
  };

  const handleUpdateEmail = (event) => {
    setLoginEmail(event.target.value);
  };

  const handleUpdatePassword = (event) => {
    setLoginPassword(event.target.value);
  };

  const handleForgotPassword = async () => {
    if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(loginEmail)) {
      try {
        await sendPasswordResetEmail(auth, loginEmail);
        setUserMessage("Password reset email sent.");
      } catch (error) {
        if (error.code === "auth/user-not-found") {
          setUserMessage("That email address has not been found.");
        }
      }
    } else {
      setUserMessage("Please enter a valid email address.");
    }
  };

  useEffect(() => {
    const auth = getAuth();
    if (auth.currentUser != null) {
      navigate("/dashboard");
    }
  }, [user.uid]);

  return (
    <Layout showNavbar={false}>
      <div className="login">
        <Logo />
        <form className="login__form" onSubmit={login}>
          <h1 className="login__heading">Welcome!</h1>
          {userMessage}
          <TextInput
            labelText="Email"
            onChangeEvent={handleUpdateEmail}
            inputType="email"
          />

          <div className="login__visibility-box">
            <TextInput
              labelText="Password"
              onChangeEvent={handleUpdatePassword}
              inputType="password"
              visibilityOption={true}
            />
          </div>

          <Button label="Log in" type="submit" />
          <p className="login__bottom-text">
            Don&apos;t have an Account?{" "}
            <Link to="/registration" className="login__registration-link">
              Sign Up
            </Link>
          </p>
          <button
            className="login__forgot-password-link"
            onClick={handleForgotPassword}
            type="button"
          >
            Forgot Password
          </button>
        </form>
      </div>
    </Layout>
  );
};

export default LoginPage;
